const auditEventCategoryMap = {
    'Security': [
        'EMAIL_DOMAIN_CHANGED',
        'PASSWORD_POLICY_CHANGED',
        'MFA_POLICY_CHANGED',
        'MFA_IP_ADDRESS_ADDED',
        'MFA_IP_ADDRESS_REMOVED',
        'MFA_IP_ADDRESSES_IMPORTED',
        'ENTERPRISE_PREFERENCES_CHANGED',
        'IDENTITY_BROKERING_CHANGED',
        'ENTERPRISE_SETTINGS_CHANGED',
        'PASSWORD_RESET'
    ],
    'Accounts': [
        'UID_ACCOUNT_LINKED',
        'UID_ACCOUNT_UNLINKED',
        'BULK_MATCH_SSO_USERS'
    ],
    'Users': [
        'UID_ACCOUNT_CREATED',
        'UID_ACCOUNT_UPDATED',
        'ENTERPRISE_ADMIN_ROLE_ADDED',
        'ENTERPRISE_ADMIN_ROLE_REMOVED',
        'ORG_ADMIN_SELECTION_CHANGED',
        'BULK_ACTION_JOB_CREATED',
        'BULK_ACTION_JOB_UPDATED',
        'SSO_USER_IMPERSONATE',
        'MFA_CREDENTIAL_REMOVED'
    ],
    'Sites': [
        'INSTANCES_STATUS_CHANGED',
        'INSTANCES_UPDATED',
        'ENTERPRISE_ORGANIZATION_ADDED',
        'ENTERPRISE_ORGANIZATION_REMOVED',
        'ORGANIZATION_ATTRIBUTE_SET'
    ],
    'Audit Reports': [
        'AUDIT_REPORT_CREATED',
        'AUDIT_REPORT_UPDATED'
    ],
    'Enterprise': [
        'ENTERPRISE_GROUP_CREATED',
        'ENTERPRISE_GROUP_NAME_CHANGED',
        'ENTERPRISE_GROUP_STATUS_CHANGED',
        'ORGANIZATION_RELOCATED'
    ],
    'Access': [
        'ACCESS_ROLE_GRANTED',
        'ACCESS_ROLE_UPDATED',
        'ACCESS_ROLE_REVOKED'
    ]
};

export function getAuditCategories(): string[] {
    return Object.keys(auditEventCategoryMap);
}

export function getCategoryByEventName(eventName: string): string {
    for (const [category, events] of Object.entries(auditEventCategoryMap)) {
        if (events.includes(eventName)) {
            return category;
        }
    }
    return '';
}

export function getAuditEventsByCategory(key: string): string[] {
    for (const [category, events] of Object.entries(auditEventCategoryMap)) {
        if (key === category) {
            return events;
        }
    }
    return [];
}
